import { FC, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { useDynamicFormsTranslate, useRidesNavigation } from "@ryde/redux";
import {
  DATA_E2E_KEY,
  ICustomField,
  IStyledAttributes,
  Log,
  NO_VALUE_DISPLAY,
  usePrefixedRouting,
} from "@ryde/shared";
import { blueMui } from "@ryde/theme";

export const LinkToEntityCardStyled = styled(Link).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "link-to-another-entity",
})`
  color: ${blueMui.A400};
  text-decoration: underline;
  cursor: pointer;
`;

export const LinkToEditCardTemplate: FC<ICustomField> = ({
  name,
  formAttributes,
  formLabel,
}) => {
  const { getValues } = useFormContext();
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
  });
  const { getRideEditLink } = useRidesNavigation();

  const linkToEntityCardParams = formAttributes?.linkToEntityCard;
  const entityName = linkToEntityCardParams?.entityName;
  const entityId = getValues(linkToEntityCardParams?.entityIdFromField ?? "");
  const { addPrefix } = usePrefixedRouting();

  const linkPath = useMemo(() => {
    if (!linkToEntityCardParams?.entityIdFromField || !entityId) {
      return "";
    }

    switch (entityName) {
      case "ride":
        return getRideEditLink({
          id: entityId,
          keepQuery: true,
        });
      default:
        return addPrefix(`${entityName}s/edit/${entityId}`);
    }
  }, [
    addPrefix,
    entityId,
    entityName,
    getRideEditLink,
    linkToEntityCardParams?.entityIdFromField,
  ]);

  if (!linkToEntityCardParams?.entityName) {
    Log.warn("Entity name for link didn't provided");
    return NO_VALUE_DISPLAY;
  }

  if (!linkToEntityCardParams.entityIdFromField) {
    Log.warn("Entity id from field for link didn't provided");
    return NO_VALUE_DISPLAY;
  }

  if (!entityId) {
    Log.warn("Entity id for link didn't found");
    return NO_VALUE_DISPLAY;
  }

  return (
    <LinkToEntityCardStyled
      rel="noopener noreferrer"
      to={`${linkPath}`}
      target="_blank"
    >
      {formLabelTranslated}
    </LinkToEntityCardStyled>
  );
};
